export default "__VITE_ASSET__62587257__"